import {connect} from 'react-redux';

import {Logo} from '../../components/Logo';

import {chargebeeActions} from '../../redux/chargebee';

function mapState(state: any) {
  return {
    client: state.client.data,
    isAdmin: state.settings.isAdmin,
    info: state.billing.info,
  };
}

const actionCreators = {
  activateRegularPlan: chargebeeActions.activateRegularPlan,
  activateRegularPlanGx: chargebeeActions.activateRegularPlanGx,
  activatePlanFromTrial: chargebeeActions.activatePlanFromTrial,
};

export const LogoContainer = connect(mapState, actionCreators)(Logo);
